export const ROUTE_404 = '/404';
export const ROUTE_429 = '/429';

export const ROUTE_POST = '/:postSlug';
export type RoutePostParams = { postSlug?: string; postId?: string };

export const ROUTE_POST_ADVANCED_SLUG = '/:year/:month(/:day)/:postSlug(/)';

export const ROUTE_LAST_POST = '/';

export const ROUTE_LOGIN = '/login';

export const ROUTE_PREVIEW_POST = '/:postId/preview/:instance(=*)';
export const ROUTE_EDIT_COMMENT = '/:postSlug/edit-comment/:commentId';
export const ROUTE_EDIT_COMMENT_ADVANCED_SLUG =
  '/:year/:month(/:day)/:postSlug/edit-comment/:commentId';
